import { EChartsOption } from 'echarts';
import { IChartData } from 'src/app/models/api/dashboards.model';

const formatNumberWithCommas = (value: number): string => {
  return value.toLocaleString('en-US');
};

export const createChartSetup = (
  chartData: IChartData[],
  legendFormatter?: (name: string) => string
): EChartsOption => {
  // Store original names for legend tooltip
  const originalNames = new Map<string, string>();
  chartData.forEach((item) => {
    const processedName = legendFormatter ? legendFormatter(item.name) : item.name;
    const trimmedName = processedName.trim();
    const maxLength = 10;
    const truncatedName = trimmedName.length > maxLength ? trimmedName.slice(0, maxLength) + '…' : trimmedName;
    originalNames.set(truncatedName, trimmedName);
  });

  return {
    textStyle: {
      fontFamily: 'Inter',
      color: '#000000',
    },
    tooltip: {
      trigger: 'item',
      formatter: (params: unknown) => {
        // @ts-ignore
        const value = formatNumberWithCommas(params.value);
        // @ts-ignore
        return `${params.name}: ${value} (${params.percent}%)`;
      },
      appendToBody: true,
    },
    series: [
      {
        right: '20%',
        left: '20%',
        bottom: '10%',
        type: 'pie',
        radius: ['65%', '80%%'],
        label: {
          color: '#000000',
          fontSize: '16',
          position: 'center',
          fontWeight: 'bold',
          fontFamily: 'Inter',
          formatter: () => {
            const total = chartData.sumBy((series) => series.value);
            return `Total\n${formatNumberWithCommas(total)}`;
          },
        },

        labelLine: {
          show: false,
        },
        avoidLabelOverlap: false,
        data: chartData,
        cursor: 'pointer',
      },
    ],
    legend: {
      type: 'scroll',
      orient: 'horizontal',
      top: 'bottom',
      pageButtonItemGap: 5,
      bottom: '5%',
      itemGap: 20,
      icon: 'circle',
      textStyle: {
        fontSize: 12,
        fontWeight: 500,
        color: '#000000',
      },
      formatter: (name: string): string => {
        const processedName = legendFormatter ? legendFormatter(name) : name;
        const trimmedName = processedName.trim();
        const maxLength = 10;
        return trimmedName.length > maxLength ? trimmedName.slice(0, maxLength) + '…' : trimmedName;
      },
      tooltip: {
        show: true,
        formatter: (params: unknown) => {
          const paramTyped = params as { name: string };
          return originalNames.get(paramTyped.name) || paramTyped.name;
        },
      },
    },
  };
};
